<div class="who_we_are custom-box1 py-3 custom-scroll-bar">
    
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <span class="breadcrumb-item">
                             <a class="bredcrumb-trimmed-text" ng-reflect-router-link="/" ng-reflect-cbic-translate="menu.Home" title="Home" href="/">Home</a>               
                        </span>
                        <span class="active breadcrumb-item">   
                            <a href="/entities/cbic-content-mst/MTY5NDM=%3D">Citizen Charter </a> 
                            <span> > </span>                       
                            <!-- <span>
                                <cbic-static-text _nghost-rxj-c120="" ng-reflect-text-en="About Us" ng-reflect-text-hi="हमारे बारे में">
                                    <span _ngcontent-rxj-c120="" class="chapter-detail-text"> About Us </span>
                                </cbic-static-text>
                            </span> -->
                        </span>
                        <span class="active breadcrumb-item">   
                            <a href="/entities/cbic-content-mst/MTY5NDE%3D">About Us </a> 
                            <span> > </span>                       
                            <!-- <span>
                                <cbic-static-text _nghost-rxj-c120="" ng-reflect-text-en="About Us" ng-reflect-text-hi="हमारे बारे में">
                                    <span _ngcontent-rxj-c120="" class="chapter-detail-text"> About Us </span>
                                </cbic-static-text>
                            </span> -->
                        </span>
                        <span> Who We Are </span>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12 pt-2">
                <!-- <h5 class=""> Who We are </h5> -->
                <div class="card shadow-sm p-4 my-2">
                    <h5> Central Board of Indirect Taxes and Customs </h5>
                    <p> Central Board of Indirect Taxes and Customs (erstwhile Central Board of Excise & Customs) is a part of the Department of Revenue under the Ministry of Finance, Government of India. It deals with the tasks of formulation of policy concerning levy and collection of Customs, Central Excise duties, Central Goods & Services Tax and IGST, prevention of smuggling and administration of matters relating to Customs, Central Excise, Central Goods & Services Tax, IGST and Narcotics to the extent under CBIC's purview. The Board is the administrative authority for its subordinate organizations, including Custom Houses, Central Excise and Central GST Commissionerates and the Central Revenues Control Laboratory. </p>
                </div>
            </div>
        </div> 
    </div>
        
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="card px-4 py-3 shadow-sm">
                    <div class="row">
                        
                        <div class="col-md-12 d-flex align-content-center align-items-center justify-content-center">
                            <div class="fc_level fc_level_bg_blue w-25 me-pointer" data-bs-toggle="modal" data-bs-target="#fc_level1_setting_icon"> 
                                <span>
                                    Ministry Of Finance
                                    <span><img src="/content/images/about_members/setting_icon.png" alt="setting_icon" width="20" /></span>
                                </span>
                            </div>
                        </div>
                    </div> 
                    
                    <div class="row">
                        <div class="col-md-12">
                            <div class="col-md-12 d-flex align-content-center align-items-center justify-content-center">
                                <div class="vertical_flow_line"></div>
                            </div>
                            <span class="flow_line"></span>
                        </div>
                            
                        <div class="col-md-2">
                            <div class="fc_level fc_level_bg_blue"> Department Of Expenditure </div>
                        </div>
                        <div class="col-md-2 mt_negative30">
                            <div class="col-md-12 d-flex align-content-center align-items-center justify-content-center">
                                <div class="vertical_flow_line"></div>
                            </div>
                            <div class="fc_level fc_level_bg_blue"> Department Of Economic Affairs </div> 
                        </div>
                        <div class="col-md-2 mt_negative30">
                            <div class="col-md-12 d-flex align-content-center align-items-center justify-content-center">
                                <div class="vertical_flow_line"></div>
                            </div>
                            <div class="fc_level fc_level_bg_blue me-pointer" data-bs-toggle="modal" data-bs-target="#fc_level2_setting_icon">                                
                                <span>
                                    Department Of Revenue
                                    <span><img src="/content/images/about_members/setting_icon.png" alt="setting_icon" width="20" /></span>
                                </span>
                            </div>
                            <div class="col-md-12 d-flex align-content-center align-items-center justify-content-center">
                                <div class="vertical_flow_line"></div>
                            </div>
                        </div>
                        <div class="col-md-3 mt_negative30">
                            <div class="col-md-12 d-flex align-content-center align-items-center justify-content-center">
                                <div class="vertical_flow_line"></div>
                            </div>
                            <div class="fc_level fc_level_bg_blue"> Department Of Financial Services </div>
                        </div>
                        <div class="col-md-3">
                            <div class="fc_level fc_level_bg_blue"> Department Of Investment and Public Asset Management </div>
                        </div>
                    </div>
    
                    <div class="row">    
                        <div class="col-md-12"> 
                            <span class="flow_line"></span> 
                        </div>             
                        <div class="col-md-3">
                            <div class="fc_level fc_level_bg_blue">
                                Additional Secretary (Admin) (HQ's Administration of Department of Revenue)
                            </div>                        
                        </div>
    
                        <div class="col-md-2 mt_negative30">
                            <div class="col-md-12 d-flex align-content-center align-items-center justify-content-center">
                                <div class="vertical_flow_line"></div>
                            </div>
                            <p class="fc_level fc_level_bg_blue"> Chairman (Central Board of Direct Taxes) </p>
                        </div>
    
                        <div class="col-md-2 mt_negative30">
                            <div class="col-md-12 d-flex align-content-center align-items-center justify-content-center">
                                <div class="vertical_flow_line"></div>
                            </div>
                            <div class="fc_level fc_level_bg_blue" data-bs-toggle="modal" data-bs-target="#chairman">
                                Chairman (Central Board of Indirect Taxes & Customs)
                                <img src="/content/images/about_members/member_icon.gif" class="img-fluid w-25 rounded-circle" alt="member_icon" width="20" />
                            </div>
                        </div>
    
                        <div class="col-md-3 mt_negative30">
                            <div class="col-md-12 d-flex align-content-center align-items-center justify-content-center">
                                <div class="vertical_flow_line"></div>
                            </div>
                            <div class="fc_level fc_level_bg_blue">
                                Director General (Central Economic Intelligence Bureau)
                            </div>
                            <div class="col-md-12 pt-3 mt_negative30"> 
                                <div class="col-md-12 d-flex align-content-center align-items-center justify-content-center">
                                    <div class="vertical_flow_line"></div>
                                </div>
                            </div>             
                        </div>
    
                        <div class="col-md-2">
                            <div class="fc_level fc_level_bg_blue me-pointer" data-bs-toggle="modal" data-bs-target="#fc_level3_setting_icon"> 
                                <span>
                                    Attached Offices/Other bodies of Department of Revenue 
                                    <span><img src="/content/images/about_members/setting_icon.png" class="img-fluid" alt="setting_icon" width="20" /></span>
                                </span>              
                            </div>
                        </div>                    
                    </div> 

                    <div class="row">
                        <div class="col-md-5">
                            <div class="row mt_negative30">
                                <div class="col-md-12 d-flex align-content-center align-items-center justify-content-center">
                                    <div class="vertical_flow_line"></div>
                                </div>
                                <span class="flow_line"></span>                                              
                            </div>
                            <div class="row">
                                <div class="col-md-4"><p class="fc_level fc_level_bg_blue"> Additional Secretary Revision Applications </p></div>
                                <div class="col-md-4 mt_negative30">
                                    <div class="col-md-12 d-flex align-content-center align-items-center justify-content-center">
                                        <div class="vertical_flow_line"></div>
                                    </div>
                                    <p class="fc_level fc_level_bg_blue"> Joint Secretary (NC & Admin) </p>
                                </div>
                                <div class="col-md-4"><p class="fc_level fc_level_bg_blue"> Financial Advisor </p></div>
                            </div>   
                        </div>
                        <div class="col-md-2 mt_negative30">
                            <div class="col-md-12 d-flex align-content-center align-items-center justify-content-center">
                                <div class="vertical_flow_line_long"></div>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="fc_level fc_level_bg_blue">
                                Joint Secretary COFEPOSA
                            </div>
                        </div>
                    </div>
                    
    
                    <div class="row">
                        <span class="flow_line"></span>
                        <div class="col-md-2" data-bs-toggle="modal" data-bs-target="#fc_level5a_members_popup"> 
                            <div class="fc_level_bg_blue me-pointer">   
                                <span class="fc_level"> 
                                    Member Compliance Management 
                                    <img src="/content/images/about_members/member_icon.gif" class="img-fluid w-25 rounded-circle" alt="member_icon" width="20" />
                                </span>
                            </div> 
                        </div>
                        <div class="col-md-2 mt_negative30"> 
                            <div class="col-md-12 d-flex align-content-center align-items-center justify-content-center">
                                <div class="vertical_flow_line"></div>
                            </div>
                            <div class="fc_level_bg_blue me-pointer" data-bs-toggle="modal" data-bs-target="#fc_level5b_members_popup"> 
                                <span class="fc_level"> 
                                    Member Administration & Vigilance 
                                    <img src="/content/images/about_members/member_icon.gif" class="img-fluid w-25 rounded-circle" alt="member_icon" />
                                </span>
                            </div> 
                        </div>
                        <div class="col-md-2 mt_negative30"> 
                            <div class="col-md-12 d-flex align-content-center align-items-center justify-content-center">
                                <div class="vertical_flow_line"></div>
                            </div>
                            <div class="fc_level_bg_blue me-pointer" data-bs-toggle="modal" data-bs-target="#fc_level5c_members_popup">
                                <span class="fc_level"> 
                                    Member GST, Central Excise, Service Tax 
                                    <img src="/content/images/about_members/member_icon.gif" class="img-fluid w-25 rounded-circle" alt="member_icon" />
                                </span>
                            </div> 
                        </div>
                        <div class="col-md-2 mt_negative30"> 
                            <div class="col-md-12 d-flex align-content-center align-items-center justify-content-center">
                                <div class="vertical_flow_line"></div>
                            </div>
                            <div class="fc_level_bg_blue me-pointer" data-bs-toggle="modal" data-bs-target="#fc_level5d_members_popup">
                                <span class="fc_level"> 
                                    Member Tax Policy and Legal 
                                    <img src="/content/images/about_members/member_icon.gif" class="img-fluid w-25 rounded-circle" alt="member_icon" />
                                </span>
                            </div> 
                        </div>
                        <div class="col-md-2 mt_negative30"> 
                            <div class="col-md-12 d-flex align-content-center align-items-center justify-content-center">
                                <div class="vertical_flow_line"></div>
                            </div>
                            <div class="fc_level_bg_blue me-pointer" data-bs-toggle="modal" data-bs-target="#fc_level5e_members_popup">
                                <span class="fc_level"> 
                                    Member Customs 
                                    <img src="/content/images/about_members/member_icon.gif" class="img-fluid w-25 rounded-circle" alt="member_icon" />
                                </span>
                            </div> 
                        </div>
                        <div class="col-md-2">                             
                            <div class="fc_level_bg_blue me-pointer" data-bs-toggle="modal" data-bs-target="#fc_level5f_members_popup">
                                <span class="fc_level"> 
                                    Member IT & TaxPayer Services & Technology 
                                    <img src="/content/images/about_members/member_icon.gif" class="img-fluid w-25 rounded-circle" alt="member_icon" width="20" />
                                </span>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


        
    <!-- The Modal -->
    <div class="modal" id="fc_level1_setting_icon">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content popup_content">
            <div class="modal-header popup_header">
                <h5> Ministry Of Finance </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            
            <div class="modal-body custom-scroll-bar">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <ul class="pl-0 mb-0 text-decoration-underline">
                            <li> <a href="https://doe.gov.in/minister/meet-union-finance-minister" target="_blank"> Union Finance Minister </a> </li>
                            <!-- <cbic-link [linkTextEn]="caseLow.titleEn" [linkTextHi]="caseLow.titleHi" [linkEn]="caseLow.path" [linkHi]="caseLow.path" (click)="ViewPdf(doc.filePathEn)"></cbic-link> -->
                            <li> <a href="https://doe.gov.in/about-us/minister-of-state" target="_blank"> Minister of State for Finance </a> </li>
                           
                        </ul>
                    </div>
                </div>
            </div>
            </div> 
        </div>
        </div>
    </div>

    <div class="modal" id="fc_level2_setting_icon">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content popup_content">
            <div class="modal-header popup_header">
                <h5> Department of Revenue </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            
            <div class="modal-body custom-scroll-bar">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <ul>
                            <li class="text-decoration-underline me-pointer" data-bs-toggle="modal" data-bs-target="#fc_level2_intrl_link1"> Functions & Responsibilities of Department of revenue </li>
                            <li class="text-decoration-underline me-pointer" data-bs-toggle="modal" data-bs-target="#fc_level2_intrl_link2"> Functions of Various Divisions/Organizations in the Department of revenue </li>
                            <!-- <li> <a href="https://old.cbic.gov.in/htdocs-cbec/whoweare/fns-dep-rev"> Functions & Responsibilities of Department of revenue </a> </li>
                            <li> <a href="https://old.cbic.gov.in/htdocs-cbec/whoweare/Fns-div"> Functions of Various Divisions/Organizations in the Department of revenue </a> </li> -->
                        </ul>
                    </div>
                </div>
            </div>
            </div> 
        </div>
        </div>
    </div>

    <div class="modal" id="fc_level3_setting_icon">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content popup_content">
            <div class="modal-header popup_header">
                <h5> Attached Offices / Other bodies of Department of Revenue </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            
            <div class="modal-body custom-scroll-bar">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <ul>
                            <li> <a href="https://narcoticsindia.nic.in/" target="_blank"> Narcotics Control Bureau </a> </li>
                            <li> <a href="https://enforcementdirectorate.gov.in/" target="_blank"> Enforcement Directorate </a> </li>
                            <li> <a href="https://cestat.gov.in/" target="_blank"> Customs, Excise & Service Tax Appellate Tribunal(CESTAT) </a> </li>
                            <li> <a href="https://old.cbic.gov.in/htdocs-cbec/aar/aar"> Authority for Advance Rulings </a> </li>
                            <li> <a href="https://settlementcommission-cest.gov.in/home" target="_blank"> Settlement Commission </a> </li>
                            <li> <a href="https://gstcouncil.gov.in/" target="_blank"> GST Council Secretariat </a> </li>
                        </ul>
                    </div>
                </div>
            </div>
            </div> 
        </div>
        </div>
    </div>


    <div class="modal" id="chairman">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content popup_content">
            <div class="modal-header popup_header">
            <h6 class="modal-title"> Chairman (Central Board of Indirect Taxes & Customs) </h6>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            
            <div class="modal-body custom-scroll-bar">
            <div class="container">
                <div class="row py-2 mb-3 member_profile shadow">
                    <div class="col-md-12 border-bottom">
                        <h5 class="fw-bold"> Chairman </h5>
                    </div>

                    <div class="col-md-2 pt-2 d-flex justify-content-center align-items-center">
                        <img src="/content/images/about_members/shri_sanjay_kumar_agarwal.jpg" class="img-fluid" alt="Chairman Img" /> 
                    </div>

                    <div class="col-md-10 pt-3">
                        <h6 class="fw-bold"> Shri Sanjay Kumar Agarwal  </h6>
                        <p class="mb-0"> Chairman </p>
                        <p class="mb-0"><span class="fw-bold">Email:</span> <span class="">  chmn-cbic@gov.in </span></p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <p> Shri Sanjay Kumar Agarwal is Chairman, Central Board of Indirect Taxes &amp; Customs and Special Secretary to the Government of India. An officer of the 1988 batch of the Indian Revenue Service (Customs &amp; Indirect Taxes), he has worked in various capacities in Customs, Central Excise, Service Tax and GST field formations.  </p>
                        <p>He has diverse experience of working in intelligence and investigation formations of the Department, as well as Directorate handling IT backbone of the Department. He headed the Directorate General of GST Intelligence (DGGI) prior to his elevation in Board. He has also headed the Directorate General of Systems prior to that. He has done earlier stints in these key Directorates at different levels and handled complex cases of tax evasion at close quarters. </p>                       
                        <p>He has vast experience of heading major Custom Houses and Air Cargo complex at Chennai, Kandla and Mundra Ports. He remained instrumental in piloting many new initiatives on Ease of Doing Business at these locations.</p>                           
                        <p>He also has deep field experience as Commissioner in heading Service Tax and Central Excise Commissionerates prior to rollout of GST, and interaction with policy wings for rollout of GST.</p>                            
                        <p>He graduated in Engineering from Indian Institute of Technology (IIT), Roorkee and post graduated from IIT Delhi. </p>
                    </div>
                </div>
            </div>
            </div> 
        </div>
        </div>
    </div>

    <div class="modal" id="fc_level5a_members_popup">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content popup_content">
            <div class="modal-header popup_header">
            <h6 class="modal-title"> Chairman (Central Board of Indirect Taxes & Customs) </h6>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            
            <div class="modal-body custom-scroll-bar">
            <div class="container">
                <div class="row py-2 mb-3 member_profile shadow">
                    <div class="col-md-12 border-bottom">
                        <h5 class="fw-bold"> Member Compliance Management </h5>
                    </div>

                    <div class="col-md-2 pt-2 d-flex justify-content-center align-items-center">
                        <img src="/content/images/about_members/profile.png" class="img-fluid" alt="Member Compliance Management Img" />                    
                    </div>

                    <div class="col-md-10 pt-3">
                        <h6 class="fw-bold">  Shri Mohan Kumar Singh </h6>
                        <p class="mb-0"> Member Compliance Management </p>
                        <p class="mb-0"><span class="fw-bold">Email:</span> <span class=""> memberinv.cbic@gov.in </span></p>
                    </div>
                </div>

                <div class="row">
                    <!-- <div class="col-md-12">
                        <p>He studied Economics at DSE, Delhi University and joined the service in 1988.  Is a recipient of Finance Minister's Gold Medal.  On the eve of Republic Day 2014, he was the awarded President of India Certificate for exceptionally distinguished record of service.</p>			
                        <p>He has diverse work experience. Headed central excise &amp; customs division in Gujarat, worked at the Large Tax Payers Unit, headed air cargo operations at Mumbai customs, and was the Zone head for sea customs at Nhava Sheva.</p>
                        <p>He headed the anti-smuggling setup at IGI Airport, and served as Deputy Director handling North zone in Directorate of Revenue Intelligence.  He supervised the Delhi zone of Directorate of GST Intelligence.</p>
                        <p>He was the Director, Public Grievances in Cabinet Secretariat (RPB) &amp; worked in the Employees Provident Fund Organization as Chief Vigilance Officer.</p>
                        <p>In the Board, he has earlier worked in the Tax Research Unit, the Public Accounts Committee unit, and the Drawback division. He joined the Board as Member on 06.09.2021.</p>
                    </div> -->
                </div>
            </div>
            </div> 
        </div>
        </div>
    </div>

    <div class="modal" id="fc_level5b_members_popup">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content popup_content">
            <div class="modal-header popup_header">
            <h6 class="modal-title"> Chairman (Central Board of Indirect Taxes & Customs) </h6>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            
            <div class="modal-body custom-scroll-bar">
            <div class="container">
                <div class="row py-2 mb-3 member_profile shadow">
                    <div class="col-md-12 border-bottom">
                        <h5 class="fw-bold"> Member Administration & Vigilance </h5>
                    </div>

                    <div class="col-md-2 pt-2 d-flex justify-content-center align-items-center">
                        <img src="/content/images/about_members/profile.png" class="img-fluid" alt="Member Administration & Vigilance Img" /> 
                    </div>

                    <div class="col-md-10 pt-3">
                        <h6 class="fw-bold"> Ms. Aruna Narayan Gupta </h6>
                        <p class="mb-0"> Member Administration & Vigilance </p>
                        <p class="mb-0"><span class="fw-bold">Email:</span> <span class=""> member-admncbic@gov.in </span></p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                    </div>
                </div>
            </div>
            </div> 
        </div>
        </div>
    </div>

    <div class="modal" id="fc_level5c_members_popup">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content popup_content">
            <div class="modal-header popup_header">
            <h6 class="modal-title"> Chairman (Central Board of Indirect Taxes & Customs) </h6>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            
            <div class="modal-body custom-scroll-bar">
            <div class="container">
                <div class="row py-2 mb-3 member_profile shadow">
                    <div class="col-md-12 border-bottom">
                        <h5 class="fw-bold">  Member GST,Central Excise,Service Tax </h5>
                    </div>

                    <div class="col-md-2 pt-2 d-flex justify-content-center align-items-center">
                        <img src="/content/images/about_members/shri_shashank_priya.jpg" class="img-fluid" alt="Member GST,Central Excise,Service Tax Img" /> 
                    </div>

                    <div class="col-md-10 pt-3">
                        <h6 class="fw-bold"> Shri Shashank Priya </h6>
                        <p class="mb-0"> Member GST,Central Excise,Service Tax </p>
                        <p class="mb-0"><span class="fw-bold">Email:</span> <span class=""> member-gst.cbic@gov.in </span></p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <p><b>Education Qualification :</b>  M.A. , L.L.B</p>
                    </div>
                </div>
            </div>
            </div> 
        </div>
        </div>
    </div>

    <div class="modal" id="fc_level5d_members_popup">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content popup_content">
            <div class="modal-header popup_header">
            <h6 class="modal-title"> Chairman (Central Board of Indirect Taxes & Customs) </h6>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            
            <div class="modal-body custom-scroll-bar">
            <div class="container">
                <div class="row py-2 mb-3 member_profile shadow">
                    <div class="col-md-12 border-bottom">
                        <h5 class="fw-bold"> Member Tax Policy and Legal </h5>
                    </div>

                    <div class="col-md-2 pt-2 d-flex justify-content-center align-items-center">
                        <img src="/content/images/about_members/profile.png" class="img-fluid" alt="Member Tax Policy and Legal Img" /> 
                    </div>

                    <div class="col-md-10 pt-3">
                        <h6 class="fw-bold"> Shri Vivek Ranjan </h6>
                        <p class="mb-0"> Member Tax Policy and Legal </p>
                        <p class="mb-0"><span class="fw-bold">Email:</span> <span class=""> Mem-taxpolicycbic@gov.in </span></p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                    </div>
                </div>
            </div>
            </div> 
        </div>
        </div>
    </div>

    <div class="modal" id="fc_level5e_members_popup">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content popup_content">
            <div class="modal-header popup_header">
            <h6 class="modal-title"> Chairman (Central Board of Indirect Taxes & Customs) </h6>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            
            <div class="modal-body custom-scroll-bar">
            <div class="container">
                <div class="row py-2 mb-3 member_profile shadow">
                    <div class="col-md-12 border-bottom">
                        <h5 class="fw-bold"> Member Customs </h5>
                    </div>

                    <div class="col-md-2 pt-2 d-flex justify-content-center align-items-center">
                        <img src="/content/images/about_members/shri_surjit_bhujabal.jpg" class="img-fluid" alt="Member Customs Img" /> 
                    </div>

                    <div class="col-md-10 pt-3">
                        <h6 class="fw-bold"> Shri Surjit Bhujabal </h6>
                        <p class="mb-0"> Member (Customs) </p>
                        <p class="mb-0"><span class="fw-bold">Email:</span> <span class=""> membercus.cbic@gov.in </span></p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <p>Born in Bhubaneswar (Odisha) and an Alumni of the Indian Institute of Technology, Delhi and Baxi Jagabandhu Bidyadhar College, Bhubaneswar. Shri Surjit Bhujabal is a Master in Science (Chemistry) &amp; Masters in Technology (Modern Methods in Chemical Analysis). He obtained the Masters in Business Administration (Public Policy) and Masters in Science (Business Administration) from University of Ljubljana Slovenia, as part of the Government of India's Long term Foreign Training Program.</p>
                        <p>A Civil Servant from the 1989 Batch of UPSC results, Shri Bhujabal opted for the Indian Revenue Service (Customs &amp; Indirect Taxes), and has served in various parts of the county, viz. New Delhi, Hyderabad, Bhubaneswar, Kolkata, Jamshedpur, Bangalore in formations including the Directorate of Revenue Intelligence &amp; the Directorate of GST intelligence (erstwhile Directorate of Central Excise Intelligence), etc. He served as Director in the Ministry of Chemicals &amp; Fertilizers (Department of Chemicals &amp; Petrochemicals).</p>
                        <p>He has special interests in wildlife preservation and has completed a Master Thesis on the Management of Tiger Reserves in India. He has served as a Jury Member for Earth Heroes Awards and India Sustainability Awards, and participated, in a voluntary capacity in field-level biodiversity conservation activities. He has chaired Study Groups on:  (1) Modernization of Intelligence Apparatus in CBIC, (2) Arrests under Central Excise Law &amp; Customs, (3) Role of Customs in Wildlife Preservation, (4) Customs, etc.</p>
                    </div>
                </div>
            </div>
            </div> 
        </div>
        </div>
    </div>

    <div class="modal" id="fc_level5f_members_popup">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content popup_content">
            <div class="modal-header popup_header">
            <h6 class="modal-title"> Chairman (Central Board of Indirect Taxes & Customs) </h6>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            
            <div class="modal-body custom-scroll-bar">
            <div class="container">
                <div class="row py-2 mb-3 member_profile shadow">
                    <div class="col-md-12 border-bottom">
                        <h5 class="fw-bold"> Member IT & TaxPayer Services & Technology </h5>
                    </div>

                    <div class="col-md-2 pt-2 d-flex justify-content-center align-items-center">
                        <img src="/content/images/about_members/profile.png" class="img-fluid" alt="Member IT & TaxPayer Services & Technology Img" /> 
                    </div>

                    <div class="col-md-10 pt-3">
                        <h6 class="fw-bold">  Shri Yogendra Garg </h6>
                        <p class="mb-0"> Member IT & TaxPayer Services & Technology </p>
                        <p class="mb-0"><span class="fw-bold">Email:</span> <span class=""> memberit-cbic@gov.in </span></p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <!-- member description here -->
                    </div>
                </div>
            </div>
            </div> 
        </div>
        </div>
    </div>

    <div class="modal" id="fc_level2_intrl_link1">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content popup_content">
            <div class="modal-header popup_header">
            <h6 class="modal-title"> Functions and structure of the Department of Revenue </h6>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            
            <div class="modal-body custom-scroll-bar abt_modal_body">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <p>The Department of Revenue is mainly responsible for the following functions: -</p>
                            <ul class="abt_modal_body_ul">
                            <li>All matters relating to levy and collection of Direct Taxes.</li>
                            <li>All matters relating to levy and collection of Indirect Taxes.</li>
                            <li>Investigation into economic offences and enforcement of economic laws.</li>
                            <li>Framing of policy for cultivation, export and fixation of price of Opium etc.</li>
                            <li>Prevention and combating abuse of Narcotic drugs and psychotropic substances and illicit traffic therein.</li>
                            <li>Enforcement of FEMA and recommendation of detention under COFEPOSA.</li>
                            <li>Work relating to forfeiture of property under Smugglers and Foreign Exchange Manipulators (Forfeiture of Property) Act, 1976 and Narcotics Drugs and Psychotropic Substances Act, 1985. </li>
                            <li>Levy of taxes on sales in the course of inter-state trade or commerce.</li>
                            <li>Matters relating to consolidation/reduction/exemption from payment of Stamp duty under Indian Stamp Act, 1899. </li>
                            <li> Residual work of Gold Control </li>
                            <li> Matters relating to CESTAT. </li>
                            <li> Cadre Control of IRS (Group-A) and IRS (C&CE) (Group-A). </li>
                        </ul>
                    </div>
                </div>
            </div>
            </div> 
        </div>
        </div>
    </div>

    <div class="modal" id="fc_level2_intrl_link2">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content popup_content">
            <div class="modal-header popup_header">
            <h6 class="modal-title"> Functions of the various Divisions/Organisations in Department of Revenue </h6>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            
            <div class="modal-body custom-scroll-bar abt_modal_body">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h6> ADMINISTRATION DIVISION: </h6>
                        <p>All administrative matters of Department of Revenue. Maintenance of CR Dossiers of the staff and officers of the Secretariat proper of the Department and IRS (IT), IRS (Custom & Central Excise) of the level of Chief Commissioners and above. </p>

                        <h6> SALES TAX DIVISION: </h6>
                        <p>Administration of sales tax laws (Validation) Act, 1956, Central Sales Tax, State-level Value Added Tax (VAT), Indian Stamp Act, 1989 etc. </p>

                        <h6> NARCOTICS CONTROL DIVISION: </h6>
                        <p> Framing of licensing policy for cultivation of Opium poppy, production of opium and export and pricing of opium. Coordination of the working of Committee of Management and issues relating of UN and International Organizations. </p>

                        <h6> COMMITTEE OF MANAGEMENT: </h6>
                        <p>Administering the departmental undertakings viz. Govt. Opium and Alkaloid work Neemuch (M.P.) and Ghazipur which are engaged in processing of raw opium for export purposes and also for extraction of alkaloids from opium, which are used by the Pharmaceutical industry. </p>

                        <h6> REVISION APPLICATION UNIT: </h6>
                        <p>Work relating to revision applications filed against the orders of Commissioners of Customs (Appeals) and Commissioners of Central Excise (Appeals) and the cases filed before 11.10.1982 against CBIC. </p>

                        <h6> INTEGRATED FINANCE UNIT: </h6>
                        <p>Tendering advice in all financial matters pertaining to Department of Revenue and the field formations under CBDT & CBIC. Deals with expenditure and financial proposals.Prepare expenditure budget for grants relating to Department of Revenue, Direct Taxes & Indirect Taxes.</p>

                        <h6> CENTRAL BOARD OF EXCISE AND CUSTOMS: </h6>
                        <p>All matters relating to levy and collection of indirect taxes.</p>

                        <h6> CENTRAL BOARD OF DIRECT TAXES:  </h6>
                        <p>All matters relating to levy and collection of direct taxes.</p>

                        <h6>COMPETENT AUTHORITY CELL: </h6>
                        <p>Administration of Smugglers and Foreign Exchange Manipulators (Forfeiture of Property) Act, 1976 and issues relating to Competent Authorities and Appellate Tribunal for Forfeited Property. </p>

                        <h6>COMPETENT AUTHORITIES: </h6>
                        <p>Work relating to forfeiture of property under Smugglers and Foreign Exchange Manipulators (Forfeiture of property) Act, 1976 and Chapter VA of Narcotics Drugs and Psychotropic Substances Act, 1985. </p>

                        <h6> APPELLATE TRIBUNAL FOR FOFEITED PROPERTY:  </h6>
                        <p>Adjudication of appeals filed by persons against orders of forfeiture of properties passed by Competent Authorities under the SAFEM (FOP) Act, 1976 and Chapter V A of NDPS Act, 1985. </p>

                        <h6> CUSTOMS, EXCISE, SERVICE TAX APPELLATE TRIBUNAL: </h6>
                        <p> Hearing appeals against the orders of Executive Commissioners and Commissioners (Appeals). </p>

                        <h6> NATIONAL COMMITTEE FOR PROMOTION OF SOCIAL AND ECONOMIC WELFARE: </h6>
                        <p>Recommending projects of social and economic welfare to the Central Government for issuance of notification under section 35 AC of the Income Tax Act, 1961. </p>

                        <h6>AUTHORITY FOR ADVANCE RULINGS: </h6>
                        <p>Giving advance rulings on a question of law or fact specified in an application filed by Non-Residents in relation to transaction, which has been undertaken or proposed to be undertaken by the applicant. </p>

                        <h6> CUSTOMS AND CENTRAL EXCISE SETTLEMENT COMMISSION </h6>
                        <p>Settlement of applications filed by the assessees under the Customs Act and Central Excise Act. </p>

                        <h6>SETTLEMENT COMMISSION (IT/WT): </h6>
                        <p>Settlement of applications filed by the assessees under the Income Tax Act, 1961 and the Wealth Tax Act, 1957. </p>

                        <h6>CENTRAL ECONOMIC INTELLIGENCE BUREAU: </h6>
                        <p>Coordinating and strengthening of the intelligence gathering activities, the investigative efforts and enforcement action by various agencies concerned with investigation into economic offences and enforcement of economic laws. </p>

                        <h6>ENFORCEMENT DIRECTORATE: </h6>
                        <p>Responsible for enforcement of the provision of Foreign Exchange Management Act. Recommending cases for detention under the Conservation of Foreign Exchange and Prevention of Smuggling Activities Act, 1974. Under Foreign Exchange Management Act, 1999, the Enforcement Directorate is mandated primarily as the investigation and adjudicating agency. </p>

                        <h6>FINANCE INTELLIGENCE UNIT: </h6>
                        <p>To coordinate and strengthen collection and sharing of financial intelligence through an effective national, regional and global network to combat money laundering and related crimes. </p>


                        <p>
                            Source: 
                            <a href="http://dor.gov.in/sites/upload_files/revenue/files/UploadedFile.pdf" target="_blank">http://dor.gov.in/sites/upload_files/revenue/files/UploadedFile.pdf</a>
                        </p>
                    </div>
                </div>
            </div>
            </div> 
        </div>
        </div>
    </div>
</div>
